import { combineReducers } from 'redux';

import bookingPanelSponsoredPricingOption from './bookingPanelSponsoredPricingOption';

export default combineReducers({
  bookingPanelSponsoredPricingOption,
});
